import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
  timeout: 20000,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const BUSINESS_TYPE_OPTIONS = [
  { value: "local", label: "Local small business" },
  { value: "professional", label: "Professional services" },
  { value: "retail", label: "Retail or restaurant" },
  { value: "healthcare", label: "Healthcare" },
  { value: "manufacturing", label: "Manufacturing or distribution" },
  { value: "transportation", label: "Transportation or logistics" },
  { value: "other", label: "Other" },
];

export const BUSINESS_SIZE_OPTIONS = [
  { value: "solo", label: "Just me" },
  { value: "1-10", label: "1–10" },
  { value: "11-50", label: "11–50" },
  { value: "51-100", label: "51–100" },
  { value: "100+", label: "More than 100" },
];

export const INTEREST_OPTIONS = [
  { value: "expense", label: "Reduce operating costs" },
  { value: "technology", label: "Review technology expenses" },
  { value: "benefits", label: "Explore employee healthcare and benefits" },
  { value: "tax", label: "Investigate potential tax credits" },
  { value: "unsure", label: "Not sure — help me decide" },
];

export const INTEREST_LABELS = {
  expense: "Business Expense Savings",
  technology: "Technology Savings",
  benefits: "Employee Healthcare & Benefits",
  tax: "Business Tax Credits & Incentives",
  unsure: "General exploration",
};

export const SERVICE_PAGES = {
  expense: {
    key: "expense",
    path: "/expense-savings",
    short: "Business Expense Savings",
    card: "Business Expenses",
    preselectLabel: "Business Expense Savings",
  },
  technology: {
    key: "technology",
    path: "/technology-savings",
    short: "Technology Savings",
    card: "Technology",
    preselectLabel: "Technology Savings",
  },
  benefits: {
    key: "benefits",
    path: "/healthcare-benefits",
    short: "Employee Healthcare & Benefits",
    card: "Employee Benefits",
    preselectLabel: "Employee Healthcare & Benefits",
  },
  tax: {
    key: "tax",
    path: "/tax-credits-incentives",
    short: "Tax Credits & Incentives",
    card: "Tax Opportunities",
    preselectLabel: "Business Tax Credits & Incentives",
  },
};

export function serviceFromQuery(query) {
  const map = {
    expense: "expense",
    "expense-savings": "expense",
    technology: "technology",
    "technology-savings": "technology",
    benefits: "benefits",
    "healthcare-benefits": "benefits",
    tax: "tax",
    "tax-credits-incentives": "tax",
  };
  return map[query] || null;
}

export async function submitLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}
